const trimAndCollapseSpaces = (text: string): string => {
  return text.replace(/\s+/g, ' ').trim()
}

export default trimAndCollapseSpaces
